import React from "react"
import SectionComponent from "./SectionComponent"


const RecruitmentComponent = (props) =>
{
    return(
        <div className="major-sections">
            {props.recruitmentChannelsList != undefined
            && props.recruitmentChannelsList['recruit'].length > 0 &&
            <SectionComponent key={'recruit'}
                id={'recruit'}
                name={''}
                attributes={props.recruitmentChannelsList}
                setAttributes={props.setRecruitmentChannelsList}
                highlightErrors={props.highlightErrors}
            />
            }
        </div>
    )
}

export default RecruitmentComponent